import { FormBase } from 'core/components';

export default class VendorsEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'VENDORS.EDIT.NAME_LABEL',
                    placeholder: 'VENDORS.EDIT.NAME_PLACEHOLDER',
                    rules: ['string', 'required'],
                },
            ],
        };
    }
}
